import { cn } from "@newxsystems/shared";
import { SproutCardLink } from "../SproutCardLink/SproutCardLink";
import { SproutMedia } from "../SproutMedia/SproutMedia";
import { SproutRichText } from "../SproutRichText/SproutRichText";
import type { IImageContentGridBottomProps } from "./ImageContentGridBottom.props";

const columns = {
  1: "grid-cols-1",
  2: "grid-cols-1 sm:grid-cols-2",
  3: "grid-cols-1 sm:grid-cols-2 md:grid-cols-3",
  4: "grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4",
} as const;

export const ImageContentGridBottom = ({
  columnCount,
  imageAspectRatio,
  items,
}: IImageContentGridBottomProps) => (
  <div className={cn("grid gap-5", columns[columnCount || 3])}>
    {items.map((item, index) => (
      <SproutCardLink
        className={cn(
          "sprout-paper-lift flex flex-col overflow-hidden",
          index % 2 === 0 ? "bg-cloud" : "bg-sunflower/25",
        )}
        key={index}
        link={item.cardLink}
      >
        <div className="relative flex-1 p-7 pt-11 after:absolute after:left-7 after:top-0 after:h-6 after:w-16 after:rounded-b-lg after:bg-coral md:p-9 md:pt-12">
          <h3 className="font-sprout-display text-3xl font-bold leading-tight transition-colors group-hover:text-primary">
            {item.heading}
          </h3>
          {item.description ? (
            <SproutRichText
              className="mt-4 text-base text-basalt md:text-lg"
              content={item.description}
            />
          ) : null}
        </div>
        <SproutMedia
          aspectRatio={imageAspectRatio || "16:9"}
          className="m-3 w-auto rounded-[1rem_1rem_1rem_0.25rem] border-4 border-whiteboard"
          media={item.image.image}
          sizes="(min-width: 1024px) 33vw, (min-width: 640px) 50vw, 100vw"
        />
      </SproutCardLink>
    ))}
  </div>
);

ImageContentGridBottom.displayName = "Content::ImageContentGridBottom";
